import { render, staticRenderFns } from "./RagioneriaMenuView.vue?vue&type=template&id=5c943f5e&"
import script from "./RagioneriaMenuView.vue?vue&type=script&lang=ts&"
export * from "./RagioneriaMenuView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports